"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault")["default"];
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.Erp = void 0;
var _forEach = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/for-each"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));
var Erp = /*#__PURE__*/function () {
  function Erp(json) {
    (0, _classCallCheck2["default"])(this, Erp);
    this.cod = null;
    this.des = null;
    this.gnt = null;
    this["var"] = null;
    this.flmis = null;
    this.desFromTable = null;
    this.desTrad = null;
    this.level = null;
    this.dl = null;
    this.da = null;
    this.dp = null;
    this.varHeadDiff = null;
    this.vartrad = null;
    this.supplier = null;
    this.supplierCod = null;
    this.alternativeCode = '';
    this.tipo4 = null;
    this.qt = 0;
    this.punit = 0;
    this.sctot = 0;
    this.mat = 0;
    this.bom = [];
    this.bop = [];
    this.camp = [];
    this.taxes = [];
    this.customerFields = {};
    this.customDataFe = {};
    this.visible = true;
    this.cod = json.cod || null;
    this.des = json.des || null;
    this.gnt = json.gnt || null;
    this["var"] = json["var"] || null;
    this.flmis = json.flmis || null;
    this.desFromTable = json.desFromTable || null;
    this.desTrad = json.desTrad || null;
    this.tipo4 = json.tipo4 || null;
    this.qt = json.qt || 0;
    this.punit = json.punit || 0;
    this.sctot = json.sctot || 0;
    this.mat = json.mat || 0;
    this.bom = json.bom || [];
    this.bop = json.bop || [];
    this.camp = json.camp || [];
    this.taxes = json.taxes || [];
    this.customerFields = json.customerFields || {};
    this.customDataFe = json.customDataFe || {};
    this.level = json.level || null;
    this.dl = json.dl || null;
    this.da = json.da || null;
    this.dp = json.dp || null;
    this.varHeadDiff = json.varHeadDiff || null;
    this.vartrad = json.vartrad || null;
    this.supplier = json.supplier || null;
    this.supplierCod = json.supplierCod || null;
    this.alternativeCode = json.alternativeCode || '';
    this.visible = json.hasOwnProperty('visible') ? json.visible : true;
    this.checkFields(json);
  }
  (0, _createClass2["default"])(Erp, [{
    key: "recalcPunit",
    value: function recalcPunit() {
      var _context,
        _this = this;
      (0, _forEach["default"])(_context = this.bop).call(_context, function (r) {
        _this.punit += r.pr * r.qty;
      });
    }
  }, {
    key: "totalEtax",
    value: function totalEtax() {
      var _context2;
      var ris = 0;
      (0, _forEach["default"])(_context2 = this.taxes).call(_context2, function (tax) {
        ris += tax.smETax ? tax.smETax : 0;
      });
      return ris;
    }
  }, {
    key: "getTotal",
    value: function getTotal() {
      var withTaxes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var withCamp = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var withQt = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      var etax = 0;
      if (withTaxes) etax = this.totalEtax();
      var campaign = 0;
      if (withCamp) campaign = this.sctot;
      var ris = this.punit + etax;
      if (withQt) {
        ris = this.qt * ris;
        campaign = this.qt * campaign;
      }
      return ris - campaign;
    }
  }, {
    key: "getWeight",
    value: function getWeight() {
      var _context3;
      var tot = 0;
      (0, _forEach["default"])(_context3 = this.bop).call(_context3, function (y) {
        tot += y.qty * y.peso || 0;
      });
      return tot;
    }
  }, {
    key: "getVolume",
    value: function getVolume() {
      var _context4;
      var tot = 0;
      (0, _forEach["default"])(_context4 = this.bop).call(_context4, function (y) {
        tot += y.qty * y.volume || 0;
      });
      return tot;
    }
  }, {
    key: "checkFields",
    value: function checkFields(json) {}
  }]);
  return Erp;
}();
exports.Erp = Erp;
//# sourceMappingURL=Erp.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@3cad/nextcore/lib/commonjs/classes/Erp.js
// module id = 300
// module chunks = 142